<template>
  <div>
    <main class="main">
      <div class="bredcumb">
        <div class="container">
          <ul>
            <!-- <router-link  :key="index" v-for="(breadcrumb, index) in $store.state.breadcrumb"  tag="li" :to="breadcrumb.path"><a>{{breadcrumb.name}}</a></router-link> -->
            <li><router-link to="/index"><a href="/index">首頁</a></router-link></li>
            <li>鯨選大師</li>
          </ul>
        </div>
      </div>

      <!-- <div class="category">
          <div class="trigger">
              <div class="container">
                  全部課程
              </div>
          </div>
          <div class="container">
              <div class="content">
                  <ul>
                      <li class="current"><a href="#">全部課程</a></li>
                      <li><a href="#">文學賞析</a></li>
                      <li><a href="#">哲學思維</a></li>
                      <li><a href="#">文化探究</a></li>
                      <li><a href="#">經典名著</a></li>
                      <li><a href="#">詩詞朗讀</a></li>
                      <li><a href="#">健康養生</a></li>
                      <li><a href="#">家庭親子</a></li>
                      <li><a href="#">心靈成長</a></li>
                      <li><a href="#">兩性情感</a></li>
                      <li><a href="#">藝術休閒</a></li>
                      <li><a href="#">經營管理</a></li>
                      <li><a href="#">創新創業</a></li>
                      <li><a href="#">趨勢分析</a></li>
                      <li><a href="#">投資理財</a></li>
                      <li><a href="#">自我提升</a></li>
                  </ul>
              </div>
          </div>
      </div> -->

      <div class="bodyContent">
        <div class="container">
          <!-- <section class="conditionSection">
              <fieldset>
                  <legend>排序：</legend>
                  <div class="inputText">
                      <select name="" id="">
                          <option selected="selected" value="%">依上架時間</option>
                          <option value="01">依更新時間</option>
                          <option value="02">依熱門排序</option>
                      </select>
                  </div>
              </fieldset>
          </section> -->
          <section class="normalList">
            <ul class="tutor tutor_style3">
              <li v-for="(authorDatas) in sort(paginationAuthorData)" :key='authorDatas.id'>
                <div class="wrap"  >
                  <div class="hd">
                    <figure>
                      <div class="graphic"><img v-bind:src="authorDatas.imgAvatar"></div>
                    </figure>
                    <figcaption>
                      <h3>{{authorDatas.title}}</h3>
                      <p v-html = substring(authorDatas.description)></p>
                    </figcaption>
                  </div>
                  <div class="lessons" v-for="(channels) in sortChannels(authorDatas.channels)" :key="channels.id">
                    <dl>
                      <dd>
                        <router-link v-bind:to="'/channel/'+channels.id">{{channels.title}}</router-link>
                      </dd>
                    </dl>
                  </div >
                </div>
              </li>
            </ul>
          </section>

          <div class="pagiContainer">
            <v-pagination
            v-model="currentPage"
            :page-count="totalPages"
            :classes="bootstrapPaginationClasses"
            ></v-pagination>
          </div>
        </div>
      </div>

    </main>
  </div>
</template>

<script>
/* eslint-disable no-undef */
import vPagination from 'vue-plain-pagination'

export default {
  components: { vPagination },

  name: 'async',
  metaInfo () {
    return {

      title: '鯨選大師 | 一刻鯨選',
      meta: [
        // OpenGraph data (Most widely used)
        { property: 'og:title', content: '鯨選大師 | 一刻鯨選' },
        { property: 'og:site_name', content: '鯨選大師 | 一刻鯨選' },
        // The list of types is available here: http://ogp.me/#types
        { property: 'og:type', content: 'website' },
        // Should the the same as your canonical link, see below.
        { property: 'og:url', content: window.location.toString() },
        { property: 'og:image', content: this.$store.state.urlDomain + '/static/logo.jpg' },
        { property: 'og:image:width', content: '200' },
        { property: 'og:image:height', content: '500' },
        // Often the same as your meta description, but not always.
        { property: 'og:description', content: '匯集各領域專家，深耕知識，隨你所選！' }

      ]
    }
  },

  data () {
    return {
      authorData: [],
      paginationAuthorData: [], // 分頁後資料
      allCount: 0,
      clickId: '0',
      api_current_page: 1,
      currentPage: 1,
      totalPages: 2,
      bootstrapPaginationClasses: {
        ul: 'pagination',
        li: 'page-item',
        liActive: 'active',
        liDisable: 'disabled',
        button: 'page-link'
      }
    //   paginationAnchorTexts: {
    //     first: '«',
    //     prev: '‹',
    //     next: '›',
    //     last: '»'
    //   }
    }
  },
  updated () {
    // eslint-disable-next-line eqeqeq
    if (this.api_current_page != this.currentPage) {
      this.paginationAuthorData = []
      this.allCount = this.authorData.length

      let i = (this.currentPage - 1) * 12

      if (this.allCount > this.currentPage * 12) { // 最多12筆
        this.allCount = this.currentPage * 12
      }

      for (i; i < this.allCount; i++) {
        this.paginationAuthorData.push(this.authorData[i])
      }

      this.api_current_page = this.currentPage
    }
  },
  created () {
    this.axios
      .get(this.$store.getters.baseURL + 'authors?per_page=1000')
      .then(response => {
        let i = 0
        let j = 0

        this.authorData = response.data
        // 清除頻道size =0的
        for (i = 0; i < this.authorData.length; i++) {
          // eslint-disable-next-line eqeqeq
          if (this.authorData[i].channels.length == 0) {
            this.authorData.splice(i)
          }
        }

        // 計算分頁  12筆為一頁
        this.allCount = this.authorData.length
        this.totalPages = Math.ceil(this.authorData.length / 12)
        let size = this.authorData.length
        if (this.authorData.length > 12) {
          size = 12
        }
        for (j = 0; j < size; j++) {
          this.paginationAuthorData.push(this.authorData[j])
        }

        //    this.classData = this.stortData(response.data.data.purchase_count);
      })
      .catch(error => console.log('log:' + error))
  },

  methods: {
    channelClickListener (item, index) {
      // alert(item.id);
      const id = item[item.length - 1].id
      this.clickId = id

      // this.$router.push({ path: "/course" });
      this.$store.commit('courseId', id)
      this.$router.push({ path: '/channel/' + id, params: { id } })
    },

    changePage (page) {
      this.$router.push({ path: '/' + page })
    },
    sort: function (arr) {
      return arr.slice().sort(function (a, b) {
        return b.purchase_count - a.purchase_count
      })
    },

    substring: function (arr) {
      var index = arr.indexOf('\n')
      if (index > 0) {
        arr = arr.substring(0, index)
        arr = arr.replace('●　', '')
      }
      return arr
    },

    sortChannels: function (arr) {
      return arr.slice().sort(function (a, b) {
        return a.id < b.id ? -1 : a.id > b.id ? 1 : 0
      })
    }

  },

  mounted () {
    $('body').removeClass('index')
  }

}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/components/views/AuthorList.vue